
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/find/reset",
      function () {
        return require("private-next-pages/auth/find/reset.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/find/reset"])
      });
    }
  